<div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-5" *ngIf="f">
      
        <form [formGroup]="faForm" (ngSubmit)="onSubmit()">
            <div class="card">
              <div class="card-body">
                <h4 _ngcontent-ctb-c249="" class="card-title">Reset 2FA</h4>
              <p _ngcontent-ctb-c249="" class="card-title-desc">Resetting 2FA involves removing the existing 2FA setup on an
                account and replacing it with a new one for enhanced security..</p>
                <div class="row">
                    <div class="col-lg-12">
                      <div class="row quicksetting-lable">
                        <div class="col-sm-5 mt-2">
                          <label for="username" class="form-label"
                            >Username/Email*<img src="assets\images\!.png"
                          /></label>
                        </div>
                        <div class="col-xl-6 col-lg-12">
                            <input type="text" class="form-control" id="username"
                            placeholder="Username/Email" formControlName="username"
                            [ngClass]="{
                                'has-error':
                                    !f.get('username').valid &&
                                    (f.get('username').touched)
                                }"/>

                              <div
                                class="form-text text-danger"
                                *ngIf="
                                    !f.get('username').valid &&
                                    (f.get('username').touched) ">

                                    Please provide a username/Email.
                              </div>
                        </div>

                    </div>
                    </div>
                </div>
                </div>
            </div>


          <div class="form-btn">
            <div class="d-flex flex-wrap gap-2">
              <div>
                <button (click)="goBack()" class="cancel-btn me-3" >Cancel</button>
              </div>
              <div>
                <button *ngIf="!isLoading" class="save-btn" type="submit">
                   Reset 2FA
                </button>
                <button class="save-btn" disabled *ngIf="isLoading">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="pl-2">&nbsp;&nbsp;Reset 2FA</span>
                </button>
              </div>
            </div>
          </div>


        </form>
      </div>
    </div>
  </div>
